import React, { useState } from 'react';
import axios from 'axios';

const API_URL = 'http://localhost:5000';

function LoginForm({ onLoginSuccess }) {
  const [email, setEmail] = useState('facilitator@example.com');
  const [password, setPassword] = useState('FacilitatorPass123');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      const response = await axios.post(`${API_URL}/auth/login`, {
        email,
        password,
      });

      const { token, user } = response.data;
      onLoginSuccess(token, user.id, user.name);
    } catch (err) {
      setError(err.response?.data?.message || 'Login failed. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="form-card">
      <h2 className="form-title">Login</h2>

      {error && <div className="form-error">{error}</div>}

      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label>Email</label>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </div>

        <div className="form-group">
          <label>Password</label>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
        </div>

        <div className="form-actions">
          <button
            type="submit"
            className="btn btn-primary"
            disabled={loading}
          >
            {loading ? <span className="loading">⏳</span> : 'Login'}
          </button>
        </div>

        <div style={{ marginTop: '30px', padding: '15px', background: '#f0f0f0', borderRadius: '5px', fontSize: '12px', color: '#555' }}>
          <div style={{ fontWeight: 'bold', marginBottom: '10px' }}>Demo Credentials:</div>
          <div style={{ marginBottom: '8px' }}>
            <strong>Admin:</strong> admin@example.com / AdminPass123
          </div>
          <div style={{ marginBottom: '8px' }}>
            <strong>Facilitator:</strong> facilitator@example.com / FacilitatorPass123
          </div>
          <div>
            <strong>Contributor:</strong> contributor@example.com / ContributorPass123
          </div>
        </div>
      </form>
    </div>
  );
}

export default LoginForm;
